var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdownBookmarked = function SvgDropdownBookmarked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 5.101v10.89c0 .473.294.873.735 1.019.129.036.258.073.386.073.313 0 .625-.146.828-.383L10 13.186l3.033 3.496c.294.364.772.492 1.232.328.44-.164.735-.565.735-1.02V5.101c0-1.202-.993-2.185-2.206-2.185H7.206C5.993 2.916 5 3.899 5 5.101m8.53 0v9.906l-2.684-3.077a1.076 1.076 0 0 0-.846-.401c-.33 0-.643.146-.846.382l-2.683 3.096V5.1c0-.4.33-.728.735-.728h5.57c.422 0 .753.328.753.728"
  })));
};
export default SvgDropdownBookmarked;